<template>
  <div class="animated fadeIn">
    <b-card :no-body="true" class="mb-md-0">
      <b-card-body class="p-0 clearfix">
        <b-row class="no-gutters" align-v="center">
          <b-col cols="3" :class="`bg-${variant} text-center`">
            <div class="p-4">
              <i :class="`fal fa-${faIcon} font-2xl`"></i>
            </div>
          </b-col>
          <b-col class="px-3">
            <div v-if="topText" class="h5 text-primary mb-1">{{ topText }}</div>
            <div v-if="bottomText" class="text-uppercase font-weight-bold">
              {{ bottomText }}
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "GeneralTile",
  props: ["topText", "bottomText", "faIcon", "variant", "to"],
};
</script>
